import {Component, OnInit} from '@angular/core';

/**
 * This class represents the footer component.
 */
@Component({
    moduleId: module.id,
    selector: 'hbs-footer',
    templateUrl: 'footer.component.html'
})
export class FooterComponent implements OnInit {

    copyYear: number;


    ngOnInit() {
        this.copyYear = Math.max(new Date().getFullYear(), 2017);
    }

}
